import { render, staticRenderFns } from "./channelLottery.vue?vue&type=template&id=a762f04c&"
import script from "./channelLottery.vue?vue&type=script&lang=js&"
export * from "./channelLottery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports